import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Grid,
  AppBar,
  Toolbar,
  MenuItem,
  Typography,
  withStyles,
} from '@material-ui/core'
import {
  Add as AddIcon,
  Edit as EditIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
} from '@material-ui/icons'

import {
  ROUTES,
  IS_SHOP,
  IS_ADMIN,
  LIST_TYPE,
} from '../constant'
import {
  getMarket,
  addQrcode,
  triggerSendQRCode,
  triggerToggleShop,
  getMarketByUserId,
  getMarketTransactions,
  triggerRefundMarketTransactions,
} from '../actions/market'
import { navigate } from '../actions/app'
import Inline from '../components/Inline'
import Qrcode from '../components/Qrcode'
import Button from '../components/Button'
import Section from '../components/Section'
import Select from '../components/Select'
import Loading from '../components/Loading'
import Breadcrumb from '../components/Breadcrumb'
import TableAutomation from '../components/TableAutomation'
import { ErrorText } from '../components/Text'


const styles = theme => ({
  root: {
    paddingTop: 0,
    padding: theme.spacing(1),
  },
  marginTop: {
    marginTop: theme.spacing(1),
  },
  marginTop2: {
    marginTop: theme.spacing(2),
  },
  marginTop3: {
    marginTop: theme.spacing(3),
  },
  preLine: {
    whiteSpace: 'pre-line',
  },
  content: {
    paddingBottom: theme.spacing(1),
  },
  section: {
    flex: 1,
    marginRight: theme.spacing(1),
  },
  sectionItem: {
    width: '100%',
  },
  sectionInfo: {
    width: 350,
  },
  flex1: {
    flex: 1,
  },
  alertTypo: {
    width: '100%',
    display: 'block',
    textAlign: 'center',
  },
  buttonLink: {
    display: 'flex',
    textAlign: 'center',
  },
})


class Market extends Component {
  /* LIFECYCLE */

  state = {
    selected: [],
    transactionState: 'all',
  }

  /**
   * @componentWillMount
   */
  componentDidMount() {
    const { uid } = this.props.match.params

    if (uid) {
      this.props.getMarket(uid)
    }

    if (IS_SHOP) {
      this.props.getMarketByUserId()
    }
  }

  /**
   * @componentDidUpdate
   * @param {*} prevProps - Previous properties of the Component
   */
  componentDidUpdate(prevProps) {
    const { item, match } = this.props
    const { uid } = match.params

    if (uid && uid !== prevProps.match.params.uid) {
      this.props.getMarket(uid)
    }

    if (item && item.id !== (prevProps.item && prevProps.item.id)) {
      this.handleMarketTransaction()
    }
  }


  /* METHODS */

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleAddQrcode = () => this.props.addQrcode(this.props.item.id)

  handleMarketTransaction = (options = {}) => {
    const { id } = this.props.item || {}

    if (id) {
      this.props.getMarketTransactions(id, options)
    }
  }

  handleEditMarket = () => {
    if (IS_ADMIN) {
      return this.props.navigate(`${ROUTES.MARKET}/add?uid=${this.props.item.id}`)
    }

    return this.props.navigate('/edit')
  }

  handleTransactionPageChange = () => {
    this.setState({ selected: [] })
  }

  handleClickTransaction = (item) => {
    const { selected } = this.state
    const isSelected = selected.includes(item.id)

    return this.setState({
      selected: isSelected ? selected.filter(x => x !== item.id) : selected.concat(item.id),
    })
  }

  handleToggleSelectAllTransactions = () => {
    const { selected } = this.state
    const transactions = (this.props.item && this.props.item.transactions) || {}

    if (selected.length > 0) {
      return this.setState({ selected: [] })
    }

    return this.setState({ selected: (transactions.items || []).map(item => item.id) })
  }

  handleToggleShop = () => {
    this.props.triggerToggleShop(this.props.item.id)
  }

  handleRefundTransactions = () => {
    const transactionIds = this.state.selected.slice(0)

    this.props.triggerRefundMarketTransactions(this.props.item.id, transactionIds)
    return this.setState({ selected: [] })
  }

  handleChangeTransaction = (e) => {
    let refund

    this.setState({ [e.target.name]: e.target.value }, () => {
      if (this.state.transactionState === 'refund') {
        refund = true
      } else if (this.state.transactionState === 'notRefund') {
        refund = false
      }

      this.props.getMarketTransactions(this.props.item.id, { refund })
    })
  }

  handleEmailQRCode = (base64) => {
    this.props.triggerSendQRCode(this.props.item.id, base64)
  }

  getTransactionStatus = (transaction) => {
    if (transaction.refund) {
      return { data: 'OK !', display: <Typography color="secondary" variant="caption">Remboursée</Typography> }
    }

    if (transaction.error || (!transaction.success && !!transaction.handled_at)) {
      return { data: 'Erreur', display: <ErrorText>Erreur</ErrorText> }
    }

    return { data: 'Non remboursée', display: <Typography variant="caption">Non remboursée</Typography> }
  }

  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      item,
      classes,
      isLoading,
    } = this.props
    const {
      selected,
      transactionState,
    } = this.state

    const transactions = (item && item.transactions) || {}
    const isDisabled = item && item.disabled

    return (
      <div className={classes.root}>
        {IS_ADMIN && (
          <Breadcrumb
            data={[
              { label: 'Accueil', to: '/' },
              { label: 'Commerces', to: ROUTES.MARKET },
              item ? item.name : 'Commerce',
            ]}
          />
        )}

        {isLoading && <Loading />}

        {item && isDisabled && (
          <AppBar
            color="primary"
            position="static"
            className={classes.marginTop2}
          >
            <Toolbar>
              <Typography
                variant="h5"
                component="h5"
                color="inherit"
                className={classes.alertTypo}
              >
                {IS_SHOP ? 'Votre commerce est désactivé' : 'Ce commerce est désactivé'}
              </Typography>
            </Toolbar>
          </AppBar>
        )}

        <Grid container direction="row" wrap="nowrap" className={classes.content}>
          <Grid container direction="column" alignItems="center" className={classes.section}>
            <Section title="Historique des transactions" className={classes.sectionItem}>
              {IS_ADMIN && (
                <Select
                  fullWidth
                  name="transactionState"
                  value={transactionState}
                  label="Type de transactions"
                  onChange={this.handleChangeTransaction}
                >
                  <MenuItem value="all">Toutes les transactions</MenuItem>
                  <MenuItem value="refund">Transactions remboursées</MenuItem>
                  <MenuItem value="notRefund">Transactions non remboursées</MenuItem>
                </Select>
              )}

              <TableAutomation
                {...transactions}
                selected={selected}
                selectable={IS_ADMIN}
                className={classes.marginTop3}
                onClick={this.handleClickTransaction}
                request={this.handleMarketTransaction}
                onPageChange={this.handleTransactionPageChange}
                head={['ID', 'Date', 'Utilisateur', 'Montant', 'Statut']}
                onToggleSelectAll={this.handleToggleSelectAllTransactions}
                row={(transaction) => {
                  const values = [
                    transaction.id,
                    transaction.created_at ? moment(transaction.created_at).format('DD/MM/YYYY - HH:mm') : 'N/A',
                    { data: transaction.user.phone, display: IS_ADMIN ? <Link to={`${ROUTES.USER}/${transaction.user_id}`}>{transaction.user.phone}</Link> : transaction.user.phone },
                    `${transaction.amount || 0} €`,
                    this.getTransactionStatus(transaction),
                  ]

                  return values
                }}
              />

              {IS_ADMIN && (
                <Button
                  fullWidth
                  isLoading={isLoading}
                  disabled={!selected.length}
                  className={classes.marginTop}
                  onClick={this.handleRefundTransactions}
                >
                  Marquer {selected.length} transaction{selected.length > 0 ? 's' : ''} comme remboursée{selected.length > 0 ? 's' : ''}
                </Button>
              )}
            </Section>

            <Section title="QR Codes" className={classes.sectionItem}>
              <Grid
                container
                justify="center"
                alignItems="center"
              >
                {item && (item.qrcodes || []).map(qrcode => (
                  <Qrcode
                    key={qrcode.id}
                    value={qrcode.value}
                    isLoading={isLoading}
                    onEmailQRCode={this.handleEmailQRCode}
                  />
                ))}
              </Grid>
            </Section>
          </Grid>


          <Grid container direction="column" alignItems="center" className={classes.sectionInfo}>
            <Section title="Informations" className={classes.sectionInfo}>
              {item && (
                <>
                  <Inline>
                    <Typography>Adresse:</Typography>
                    <Typography variant="caption">{item.address}</Typography>
                  </Inline>
                  <Inline>
                    <Typography>Catégorie:</Typography>
                    <Typography variant="caption">{item.category}</Typography>
                  </Inline>
                  <Inline>
                    <Typography>Téléphone:</Typography>
                    <Typography variant="caption">{item.phone}</Typography>
                  </Inline>
                  <Inline>
                    <Typography>Site web:</Typography>
                    <Typography
                      component="a"
                      target="_blank"
                      href={item.web}
                      variant="caption"
                    >
                      {item.web}
                    </Typography>
                  </Inline>
                  {IS_ADMIN && (
                    <Inline>
                      <Typography>Mots clés:</Typography>
                      <Typography variant="caption">{item ? (item.keywords || []).join(', ') : ''}</Typography>
                    </Inline>
                  )}
                </>
              )}
            </Section>

            <Section title="Horaires" className={classes.sectionInfo}>
              {item && <Typography variant="caption" className={classes.preLine}>{item.schedule}</Typography>}
            </Section>

            <Section title="Actions" className={classes.sectionInfo}>
              {item && (
                <Button
                  fullWidth
                  color="primary"
                  isLoading={isLoading}
                  className={classes.buttonLink}
                  onClick={this.handleEditMarket}
                >
                  <EditIcon /><span className={classes.flex1}>Modifier</span>
                </Button>
              )}

              <Button
                fullWidth
                isLoading={isLoading}
                className={classes.marginTop}
                onClick={this.handleAddQrcode}
              >
                <AddIcon /><span className={classes.flex1}>Ajouter un QR Code</span>
              </Button>

              {IS_ADMIN && (
                <Button
                  fullWidth
                  disabled={!item}
                  isLoading={isLoading}
                  className={classes.marginTop3}
                  onClick={this.handleToggleShop}
                  color={item && isDisabled ? 'secondary' : 'primary'}
                >
                  {item && !isDisabled && (
                    <>
                      <LockIcon />
                      <span className={classes.flex1}>Désactiver le commerce</span>
                    </>
                  )}

                  {item && isDisabled && (
                    <>
                      <LockOpenIcon />
                      <span className={classes.flex1}>Activer le commerce</span>
                    </>
                  )}
                </Button>
              )}
            </Section>
          </Grid>
        </Grid>
      </div>
    )
  }
}

Market.defaultProps = {
  match: {
    params: {
      uid: null,
    },
  },
}


Market.propTypes = {
  item: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  getMarket: PropTypes.func.isRequired,
  addQrcode: PropTypes.func.isRequired,
  triggerSendQRCode: PropTypes.func.isRequired,
  triggerToggleShop: PropTypes.func.isRequired,
  getMarketByUserId: PropTypes.func.isRequired,
  getMarketTransactions: PropTypes.func.isRequired,
  triggerRefundMarketTransactions: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  item: state.item.type === LIST_TYPE.MARKETS ? state.item : null,
})


export default connect(mapStateToProps, {
  navigate,
  getMarket,
  addQrcode,
  triggerSendQRCode,
  triggerToggleShop,
  getMarketByUserId,
  getMarketTransactions,
  triggerRefundMarketTransactions,
})(withStyles(styles)(Market))
